<template>
  <div id="app">
    <van-button id="install-button" type="primary" style="display: none; width: 40px; height: 40px; position: fixed; border-radius: 6px; right: 5px; top: 5px; z-index: 99;">
      <img style="display: block; width: 20px; height: 20px;" src="./assets/imgs/intall_app.webp" alt="">
    </van-button>
    <router-view/>

    <div id="installpop">
      <van-popup :close-on-click-overlay="isFalse" v-model="installShow">
        <div class="install_cvi">
          <div class="install_vt">
            <van-button type="primary" style="width: 40px; height: 40px; border-radius: 6px; ">
              <img style="display: block; width: 20px; height: 20px;" src="./assets/imgs/intall_app.webp" alt="">
            </van-button>
          </div>
          <div class="install_vsolid">
            <div class="install_vs"></div>
          </div>
          <div class="install_text">
            <div class="install_tx">
              <p>¡Registro exitoso! Para evitar que se pierda, agregue la página a su pantalla principal.</p>
            </div>
          </div>
          <div class="install_btn">
            <van-button round type="default" style="width: 80px; height: 32px; font-size: 14px; font-weight: 500; color: #333333;" @click="onInstallzl">ok</van-button>
          </div>
        </div>
      </van-popup>
    </div>

  </div>
</template>

<script>
  import Vue from 'vue'

  export default {
    name: "add",
    data() {
      return {
        installShow: true,
        isFalse: false,
      }
    },
    async created() {
      let Adjust = await require('@/utils/adjust-latest.min.js');
      Vue.prototype.$adjust = Adjust;
      //console.log(this.$adjust)
      const initAD = () => {
        try {
          const isProduction = window.location.host === "www.superapoyomax.com";
          this.$adjust.initSdk({
            appToken: "fuu9smikvmyo",
            environment: isProduction ? "production" : "sandbox",
            logLevel: "verbose",
          });
          setTimeout(async () => {
            await this.$adjust.waitForAttribution().then((attr) =>
                    localStorage.setItem("adjust_id", attr.adid)
            );
          }, 1000);
        } catch (error) {
          console.error("Adjust初始化失败:", error);
          if (window.location.host !== "www.superapoyomax.com") {
            // 非生产环境显示错误
            alert(`Adjust初始化错误: ${error.message}`);
          }
        }
      };

      initAD();
    },
    mounted(){

      if (navigator.getInstalledRelatedApps) {
        navigator.getInstalledRelatedApps().then(apps => {
          if (apps.length > 0) {
            console.log('Found installed related apps:', apps);
            this.installShow = false
          } else {
            console.log('No related apps installed.');
            this.installShow = true
          }
        }).catch(error => {
          console.error('Error fetching installed apps:', error);
          this.installShow = true
        });
      } else {
        console.log('getInstalledRelatedApps is not supported on this browser.');
      }

      if (window.matchMedia('(display-mode: standalone)').matches) {
        console.log('PWA 已安装并运行在独立模式');
        this.installShow = false;
      }

      if (window.navigator.standalone) {
        console.log('PWA 已安装（iOS）');
        this.installShow = false;
      }

      window.addEventListener('hashchange',()=>{
        var currentPath = window.location.hash.slice(1); // 获取输入的路由
        if(this.$router.path !== currentPath){
          this.$router.push(currentPath); // 动态跳转
        }
      },false);

      let deferredPrompt; // 用来保存触发的事件对象

      window.addEventListener('beforeinstallprompt', (event) => {
        // 阻止浏览器自动显示安装提示
        event.preventDefault();
        deferredPrompt = event; // 保存事件对象以供后续使用
        console.log('捕获到 beforeinstallprompt 事件');

        // 显示一个安装按钮（可以动态显示）
        const installButton = document.getElementById('install-button');
        if (installButton) {
          installButton.style.display = 'block'; // 显示安装按钮
        }
      });

      const installButton = document.getElementById('install-button');
      if (installButton) {
        installButton.addEventListener('click', () => {
          if (deferredPrompt) {
            deferredPrompt.prompt(); // 触发安装弹窗

            // 监听用户的选择结果
            deferredPrompt.userChoice.then((choiceResult) => {
              if (choiceResult.outcome === 'accepted') {
                console.log('用户接受安装');
              } else {
                console.log('用户拒绝安装');
              }
              deferredPrompt = null; // 清空事件对象
            });
          }
        });
      }

      document.addEventListener('DOMContentLoaded', () => {
        let deferredPrompt;
        const installButton = document.getElementById('install-button');

        // 默认隐藏按钮
        if (installButton) {
          //installButton.style.display = 'none';
        }

        // 捕获 beforeinstallprompt 事件
        window.addEventListener('beforeinstallprompt', (event) => {
          event.preventDefault();
          deferredPrompt = event;
          console.log('捕获到 beforeinstallprompt 事件');

          // 显示安装按钮
          if (installButton) {
            installButton.style.display = 'block';
          }
        });

        // 点击按钮触发安装
        if (installButton) {
          installButton.addEventListener('click', () => {
            if (deferredPrompt) {
              deferredPrompt.prompt();
              deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                  console.log('用户接受安装');
                } else {
                  console.log('用户拒绝安装');
                }
                deferredPrompt = null;
              });
            }
          });
        }
      });

      window.addEventListener('appinstalled', () => {
        //console.log('pwa已经安装了')
      });

    },
    methods: {
      onInstallzl() {
        this.installShow = false;
      }
    }
  }
</script>

<style lang="scss">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333;
  }
  img {
    width: 100%;
    height: 100%;
    display: block;
  }
  p, ul {
    margin: 0;
  }
  a {
    text-decoration: none;
    cursor: pointer;
  }
  .mainContent {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    position: relative;
  }
  #installpop .van-popup{
    background: rgba(255, 255, 255, 0);
  }
  .install_cvi{
    width: 100vw;
    height: 100vh;
    background: rgba(255, 255, 255, 0);
  }
  .install_vt{
    width: 100%;
    height: 50px;
    box-sizing: border-box;
    padding: 10px 10px 0 0;
    display: flex;
    justify-content: flex-end;
  }
  .install_vsolid{
    width: 100%;
    height: 60px;
    box-sizing: border-box;
    padding: 0 30px 0 0;
    display: flex;
    justify-content: flex-end;
  }
  .install_vs{
    width: 1.5px;
    height: 60px;
    background: #ffffff;
  }
  .install_text{
    width: 100%;
    height: 93px;
    box-sizing: border-box;
    padding: 0 16px 0 0;
    display: flex;
    justify-content: flex-end;
  }
  .install_tx{
    width: 243px;
    height: 79px;
    background: #FFFFFF;
    border-radius: 8px;
    box-sizing: border-box;
    padding: 14px 16px;
  }
  .install_tx p{
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    line-height: 17px;
    text-align: left;
    font-style: normal;
  }
  .install_btn{
    width: 100%;
    height: 32px;
    box-sizing: border-box;
    padding: 0 16px 0 0;
    display: flex;
    justify-content: flex-end;
  }
</style>
